import { HTMLAttributes, FC, useMemo } from "react";
import clsx from "classnames";
import { useStyles } from "./Header.style";
import { Typography } from "../../core/Typography/Typography";
import { Icon } from "../../core/Icon/Icon";
import Button from "../../core/Button/Button";
import { TypographyVariant } from "../../../constants/typography";
import { useLocation } from "react-router-dom";
import { PageRoutes } from "../../../constants/routes";

interface HeaderProps extends HTMLAttributes<HTMLDivElement> {
  leftItems?: React.ReactNode;
  centerItems?: React.ReactNode;
  rightItems?: React.ReactNode;
}

export const Header: FC<HeaderProps> = (props) => {
  const { leftItems, centerItems, rightItems, className, ...otherProps } =
    props;
  const classes = useStyles();
  const location = useLocation();

  const isBackgroundTransparent = useMemo(() => {
    return [PageRoutes.Game, PageRoutes.Subscription].some((route) =>
      location.pathname.includes(route),
    );
  }, [location.pathname]);

  return (
    <div
      {...otherProps}
      className={clsx(
        classes.root,
        isBackgroundTransparent && classes.transparentBg,
        className,
      )}
    >
      {typeof leftItems === "string" ? (
        <Button
          variant="borderless"
          size="small"
          afterIcon={<Icon name={leftItems} />}
        />
      ) : (
        leftItems
      )}
      <div className={classes.centerContent}>
        {typeof centerItems === "string" ? (
          <Typography variant={TypographyVariant.BodyB4Medium}>
            {centerItems}
          </Typography>
        ) : (
          centerItems
        )}
      </div>
      {typeof rightItems === "string" ? (
        <Button
          variant="borderless"
          size="small"
          afterIcon={<Icon name={rightItems} />}
        />
      ) : (
        rightItems
      )}
    </div>
  );
};
